<template>
  <div style="height: calc(100% - 100px);">
    <div v-if="computerOrPhone=='computer'" class="computerStyle" style="width: 100vw;">
      <div  class="topTips">
        <div>区县季更一张图价格查询仅供参考，若价格变动请以最新查询结果或商务经理报价为准</div>
        <div>切片数据调用时间截至2024年12月31日</div>
      </div>
      <div class="queryDiv">
        <div class="title">区县季更图产品价格查询</div>
        <div class="mainPanel">
          <div class="mapPanel">
            <l-map
                  :maxBounds="maxBounds"
                  :minZoom="parseInt(2)"
                  ref="map"
                  style="width: 100%; height: 100%;border-radius: 32px 0px 0px 32px;"
                  :zoom="zoom"
                  :center="center"
                  :options="option"
                  :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
              >
              <template mark="map">
                  <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
                  <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
              </template>
                <!-- <l-geo-json
                      v-if="bufferGeo.geojson"
                      :geojson="bufferGeo.geojson"
                      :optionsStyle="bufferGeojsonStyle"
              ></l-geo-json> -->

              <!-- <l-geo-json
                      v-if="$store.state.search.selectedRangeStore[$store.state.search.targetType] !== ''&& !targetMode"
                      :geojson="$store.state.search.selectedRangeStore[$store.state.search.targetType]"
                      :optionsStyle="targetGeojsonStyle"
              ></l-geo-json> -->
              <l-geo-json
                      v-if="showCountyNameResult&&areaGeo"
                      :geojson="JSON.parse(areaGeo)"
                      :optionsStyle="targetGeojsonStyle"
              ></l-geo-json>



          </l-map>
          </div>
          <div class="detailPanel">
            <!-- <v-card class="vcard" color="basil"> -->
                <div style="width:576px;border-bottom:1px solid rgba(0,0,0,.1);margin:57px 20px 0 20px;position:absolute;z-index:1"></div>
                <v-tabs v-model="curPlaceTab" grow class="vtabs" color="#000000" background-color="#F7F7F7">
                    <v-tab key="explainPlace">输入区县名
                    </v-tab>
                    <v-tab key="place">区县快选
                    </v-tab>
                    <v-tab-item key="explainPlace">
                        <div class="searchField">
                          <v-text-field
                            v-model="countyName"
                            outlined
                            clearable
                            label="请输入区县名*"
                            append-icon="mdi-magnify"
                            @click:append="searchCountyByName"
                            style="width: 576px;height: 75px;margin: 27px 0 0 -10px;border-radius: 8px;"
                          ></v-text-field>

                          <div v-if="countyName" @click="showDetail" style="cursor: pointer;width: 100px;height: 44px;background: #0066CC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">查询</div>
                          <div v-else style="cursor: pointer;width: 100px;height: 44px;background: #CCCCCC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;">查询</div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="place">
                        <!-- <v-card flat style="width:100%;height:100%"> -->
                            <v-row align="center" justify="center" class="ma-2" style="margin: 24px 0 10px -15px !important; ">
                                <div style="width: 192px">
                                    <v-autocomplete ref="chinaProvince" class="ma-0 mr-2"
                                        :items="chinaProvinceItems" item-text="areaName" item-value="areaId"
                                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
                                        v-model="chinaProvinceNow" outlined dense>
                                        </v-autocomplete>
                                </div>
                                <div style="width: 192px">
                                    <v-autocomplete ref="chinaCity" class="ma-0 mr-2" :disabled="!chinaProvinceNow"
                                        :items="chinaCityItems" item-text="areaName" item-value="areaId"
                                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.city')"
                                        v-model="chinaCityNow" outlined dense>
                                        </v-autocomplete>
                                </div>
                                <div style="width: 192px">
                                    <v-autocomplete ref="chinaCounty" class="ma-0" :disabled="!chinaCityNow"
                                        :items="chinaCountyItems" item-text="areaName" item-value="areaId"
                                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.county')"
                                        v-model="chinaCountyNow" outlined dense>
                                        </v-autocomplete>
                                </div>
                            </v-row>
                            <div v-if="chinaCityNow||chinaCountyNow" @click="searchCountyById" style="cursor: pointer;width: 100px;height: 44px;background: #0066CC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;z-index: 1;">查询</div>
                          <div v-else style="cursor: pointer;width: 100px;height: 44px;background: #CCCCCC;border-radius: 8px;color:white;display: flex;align-items: center;justify-content: center;z-index: 1;">查询</div>

                        <!-- </v-card> -->
                    </v-tab-item>
                  </v-tabs>
                  <a-list class="priceResultList" item-layout="horizontal" :data-source="priceResult" v-if="priceResult.length>0">
                    <a-list-item class="searchListItem" slot="renderItem" slot-scope="item">
                        <div>
                          <a @click="searchDetail(item)">{{ item.provinceName+item.cityName+item.areaName }}</a>
                        </div>
                    </a-list-item>
                  </a-list>
                  <div>
                    <div style="width:576px;border-bottom:1px dashed rgba(0,0,0,.1);margin:50px 20px 0 20px;z-index:1"></div>
                        <div class="detail"  v-if="showCountyNameResult&&countyNameResult">
                          <div class="left">
                            <div>区县名称<span>{{countyNameResult}}</span></div>
                            <div>区县面积<span>{{parseInt(countyAreaResult)}}</span><span>km²</span></div>
                            <div>2023年单季度[限时价格]<span class="rmb">{{countyQ1Price?'￥':'—'}}</span><span class="price">{{countyQ1Price}}</span></div>
                            <!-- <div>2023年第一季度 有效数据覆盖率<span>{{countyQ1CoverRate||'—'}}</span></div>
                            <div>2023年第二季度 有效数据覆盖率<span>{{countyQ2CoverRate||'—'}}</span></div>
                            <div>2023年第三季度 有效数据覆盖率<span>{{countyQ3CoverRate||'—'}}</span></div>
                            <div>2023年第四季度 有效数据覆盖率<span>{{countyQ4CoverRate||'—'}}</span></div> -->
                          </div>
                          <!-- <div class="right">
                            <div></div>
                            <div></div>
                            <div>限时价格<span class="rmb">{{countyQ1Price?'￥':'—'}}</span><span class="price">{{countyQ1Price}}</span></div>
                            <div>限时价格<span class="rmb">{{countyQ2Price?'￥':'—'}}</span><span class="price">{{countyQ2Price}}</span></div>
                            <div>限时价格<span class="rmb">{{countyQ3Price?'￥':'—'}}</span><span class="price">{{countyQ3Price}}</span></div>
                            <div>限时价格<span class="rmb">{{countyQ4Price?'￥':'—'}}</span><span class="price">{{countyQ4Price}}</span></div>
                          </div> -->
                        </div>
                  </div>
            <!-- </v-card> -->
          </div>
        </div>
        <div style="width: 800px;height: 20px;line-height: 20px;font-size: 14px;font-weight: 400;color: #3A3A3A;text-align: center;margin-left: auto;margin-right:auto;margin-top: 20px;">
          若您有任何疑问请咨询商务经理:0431-86008580
        </div>
      </div>

    </div>
    <div v-if="computerOrPhone=='phone'" class="phoneStyle" style="width:100%;">
      <div class="topBanner">
        <img src="../assets/RS_TopNavi/logo1.png" style="width: 75%;max-width: 450px;"/>
      </div>
      <div class="topTitle">
        区县季更图产品价格查询
      </div>
      <div class="topTip">
        查询结果仅供参考，若价格变动请以最新查询结果或商务经理报价为准
      </div>
      <div class="topTip">
        切片数据调用时间截至2024年12月31日
      </div>
      <div class="topTip" style="margin-top: 1rem;">
        若您有任何疑问请咨询商务经理:0431-86008580
      </div>
      <div class="searchPanel" style="padding-top: 1px;margin-top: 1.375rem;">
        <div style="width: 90%;margin-top: 1rem;margin-left: auto;margin-right: auto;z-index: 20">
          <v-tabs v-model="curPlaceTab" grow class="vtabs" color="#000000" background-color="#F7F7F7">
            <v-tab key="explainPlace">输入区县名
            </v-tab>
            <v-tab key="place">区县快选
            </v-tab>
            <v-tab-item key="explainPlace">
              <div class="searchField">
                <v-text-field
                    v-model="countyName"
                    outlined
                    clearable
                    label="请输入区县名*"
                    append-icon="mdi-magnify"
                    @click:append="searchCountyByName"
                    style="width: 12.25rem;height: 2.75rem;margin: 0rem 0.625rem 0 0rem;border-radius: 0.5rem;"
                ></v-text-field>
                <!-- <div v-if="countyName" @click="searchCountyByName" class="button_blue" >查询</div> -->
                <div v-if="countyName" @click="showDetail" class="button_blue" >查询</div>
                <div v-else class="button_gray">查询</div>
              </div>
            </v-tab-item>
            <v-tab-item key="place">
              <!-- <v-card flat style="width:100%;height:100%"> -->
              <div class="searchField">
                <div style="width: 45%;margin-right: 2%">
                  <v-autocomplete ref="chinaProvince"
                                  :items="chinaProvinceItems" item-text="areaName" item-value="areaId"
                                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.province')"
                                  no-filter
                                  v-model="chinaProvinceNow" outlined dense>
                  </v-autocomplete>
                </div>
                <div style="width: 45%">
                  <v-autocomplete ref="chinaCity"  :disabled="!chinaProvinceNow"
                                  :items="chinaCityItems" item-text="areaName" item-value="areaId"
                                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.city')"
                                  :no-filter="true"
                                  v-model="chinaCityNow" outlined dense>
                  </v-autocomplete>
                </div>
                <div style="width: 45%;margin-right: 2%">
                  <v-autocomplete ref="chinaCounty"  :disabled="!chinaCityNow"
                                  :items="chinaCountyItems" item-text="areaName" item-value="areaId"
                                  :label="$vuetify.lang.t('$vuetify.search.rangeSelector.county')"
                                  :no-filter="true"
                                  v-model="chinaCountyNow" outlined dense>
                  </v-autocomplete>
                </div>

              <div v-if="chinaCityNow||chinaCountyNow" @click="searchCountyById" class="button_blue" style="width:45%;">查询</div>
              <div v-else class="button_gray" style="width:45%;">查询</div>
              </div>
              <!-- </v-card> -->
            </v-tab-item>
          </v-tabs>
          <a-list class="priceResultList" item-layout="horizontal" :data-source="priceResult" v-if="priceResult.length>0">
            <a-list-item class="searchListItem" slot="renderItem" slot-scope="item">
              <div>
                <a @click="searchDetail(item)" style="font-size: 0.9rem;">{{ item.provinceName+item.cityName+item.areaName }}</a>
              </div>
            </a-list-item>
          </a-list>
          <div>
            <div style="width:90%;border-bottom:1px dashed rgba(0,0,0,.1);margin:50px 20px 0 20px;z-index:1"></div>
            <div class="detail"  v-if="showCountyNameResult&&countyNameResult">
              <div class="left">
                <div>区县名称<span>{{countyNameResult}}</span></div>
                <div>区县面积<span>{{parseInt(countyAreaResult)}}</span><span>km²</span></div>
                <div>2023年单季度[限时价格]<span class="rmb">{{countyQ1Price?'￥':'—'}}</span><span class="price">{{countyQ1Price}}</span></div>
                <!-- <div>2023年第一季度 有效数据覆盖率<span>{{countyQ1CoverRate||'—'}}</span></div>
                <div>2023年第二季度 有效数据覆盖率<span>{{countyQ2CoverRate||'—'}}</span></div>
                <div>2023年第三季度 有效数据覆盖率<span>{{countyQ3CoverRate||'—'}}</span></div>
                <div>2023年第四季度 有效数据覆盖率<span>{{countyQ4CoverRate||'—'}}</span></div> -->
              </div>
              <!-- <div class="right">
                <div></div>
                <div></div>
                <div>限时价格<span class="rmb">{{countyQ1Price?'￥':'—'}}</span><span class="price">{{countyQ1Price}}</span></div>
                <div>限时价格<span class="rmb">{{countyQ2Price?'￥':'—'}}</span><span class="price">{{countyQ2Price}}</span></div>
                <div>限时价格<span class="rmb">{{countyQ3Price?'￥':'—'}}</span><span class="price">{{countyQ3Price}}</span></div>
                <div>限时价格<span class="rmb">{{countyQ4Price?'￥':'—'}}</span><span class="price">{{countyQ4Price}}</span></div>
              </div> -->
            </div>
          </div>
        </div>

      </div>
      <div class="mapPanel">
        <l-map
                :maxBounds="maxBounds"
                :minZoom="parseInt(2)"
                ref="map"
                style="width: 100%; height: 100%;border-radius: 0 0px 32px 32px;z-index: 10"
                :zoom="zoom"
                :center="center"
                :options="option"
                :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
            >
            <template mark="map">
                <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
                <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
            </template>
              <!-- <l-geo-json
                    v-if="bufferGeo.geojson"
                    :geojson="bufferGeo.geojson"
                    :optionsStyle="bufferGeojsonStyle"
            ></l-geo-json> -->

            <!-- <l-geo-json
                    v-if="$store.state.search.selectedRangeStore[$store.state.search.targetType] !== ''&& !targetMode"
                    :geojson="$store.state.search.selectedRangeStore[$store.state.search.targetType]"
                    :optionsStyle="targetGeojsonStyle"
            ></l-geo-json> -->
            <l-geo-json
                    v-if="showCountyNameResult&&areaGeo"
                    :geojson="JSON.parse(areaGeo)"
                    :optionsStyle="targetGeojsonStyle"
            ></l-geo-json>



        </l-map>
      </div>

    </div>

  </div>

</template>

<script>
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
import 'leaflet-mouse-position'
export default {
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
  },
  data() {
    return {
      computerOrPhone:'computer',
      // leaflet参数
      targetModePoint: L.latLng(380, 90),
      targetMode: false,
      zoom: 4,
      center: L.latLng(33.978292, 105.395057),
      maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
      url: this.$store.state.mapUrl,
      subdomains: this.$store.state.mapSubdomains,
      option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
      showSearchRangeSelector: false,

      targetGeojsonStyle: {
          color: '#00BCD4',
          weight: 2,
          fillOpacity: 0
      },
      bufferGeojsonStyle: {
          color: '#F44336',
          fillColor: '#F44336',
          weight: 2,
          fillOpacity: 0.1
      },
      bufferGeo: {
        geojson: '',
        area:''
      },

      //提示相关参数
      snackbar:false,
      snackbarColor:"",
      snackbarInfo:"",
      timeout: 3000,


      curPlaceTab:0,
      explainPlace: '',//输入-地点

      chinaProvinceNow: '',
      selectedProvinice:'',
      chinaCityNow: '',
      selectedCity:'',
      chinaCountyNow: '',
      selectedCounty:'',
      chinaProvinceItems:[],
      chinaCityItems:[],
      chinaCountyItems:[],
      vtabsWidth: 300,//vtabs的宽度，用于设置v-date-picker的宽度


      countyName: '',
      // detailList: [],
      priceResult:[],//查询结果

      showCountyNameResult:false,
      countyNameResult:'',
      countyAreaResult:'',
      countyQ1CoverRate:'',
      countyQ2CoverRate:'',
      countyQ3CoverRate:'',
      countyQ4CoverRate:'',
      countyQ1Price:'',
      countyQ2Price:'',
      countyQ3Price:'',
      countyQ4Price:'',
      areaGeo:'',
    };
  },
  created() {

  },
  // computed:{
  //     items() {
  //         let tmp = []
  //         tmp.push(...this.priceResult)
  //         return tmp
  //     }
  // },
  mounted() {
    this.checkScreenWidth();
    let that=this
    window.addEventListener("resize",function () {
      that.checkScreenWidth();
    })
    this.axios.get('/accessapi/searchService/Area/id=-1').then((res) => {
        this.chinaProvinceItems = res.data.data
    })
  },
  methods: {
    searchDetail(item) {
      this.priceResult = []
      // let areaId=item.areaId
      this.areaGeo = item.areaGeo
      this.countyNameResult = item.provinceName + item.cityName + item.areaName
      this.countyAreaResult = item.area
      this.countyQ1CoverRate = item.tilesQ1CoverRate
      this.countyQ2CoverRate = item.tilesQ2CoverRate
      this.countyQ3CoverRate = item.tilesQ3CoverRate
      this.countyQ4CoverRate = item.tilesQ4CoverRate
      this.countyQ1Price = item.tilesQ1Price
      this.countyQ2Price = item.tilesQ2Price
      this.countyQ3Price = item.tilesQ3Price
      this.countyQ4Price = item.tilesQ4Price

      this.countyName=this.countyNameResult

      // this.$refs.map.mapObject.fitBounds(L.geoJSON(JSON.parse(this.areaGeo)).getBounds())

      // this.axios.get('/accessapi/searchService/Area/id='+areaId).then((res) => {
      //     // this.chinaProvinceItems = res.data.data
      //     debugger
      // })

      //只是记录
      this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesInfo?areaId=' + item.areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then((res) => {
      })
    },
    showDetail() {
      this.showCountyNameResult=true
      this.$refs.map.mapObject.fitBounds(L.geoJSON(JSON.parse(this.areaGeo)).getBounds())

    },
    checkScreenWidth() {
      let screenWidth = window.innerWidth;
      if (screenWidth < 800) {
        this.computerOrPhone ='phone';
        console.log('当前是手机模式')
        //根据屏幕大小设置rem
        // 计算屏幕宽度
        let screen = document.documentElement.clientWidth;
        // 计算字体大小，取屏幕宽度的16分之一
        let scale=screen/375;//当前屏幕与设计稿比例
        let size =scale*16;
        // 设置根元素字体大小
        document.documentElement.style.fontSize = size + 'px';
      } else {
        document.documentElement.style.fontSize = '16px';
        this.computerOrPhone = 'computer';
        console.log('当前是电脑模式')
      }
    },
    searchCountyByName() {
      if (this.countyName) {
        this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesInfoList?county=' + this.countyName, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
          .then((res) => {
          this.priceResult = []
          res.data.data.forEach(item => {
            let tmp = {
              area:item.area||'',
              areaId: item.areaId||'',
              parentAreaId:item.parentAreaId||'',
              areaGeo:item.areaGeo||'',
              areaName:item.areaName||'',
              cityName: item.cityName||'',
              provinceName: item.provinceName||'',
              tilesQ1CoverRate: item.tilesQ1CoverRate||'',
              tilesQ1Price: item.tilesQ1Price||'',
              tilesQ2CoverRate: item.tilesQ2CoverRate||'',
              tilesQ2Price: item.tilesQ2Price||'',
              tilesQ3CoverRate: item.tilesQ3CoverRate||'',
              tilesQ3Price: item.tilesQ3Price||'',
              tilesQ4CoverRate: item.tilesQ4CoverRate||'',
              tilesQ4Price: item.tilesQ4Price||'',
            }
            this.priceResult.push(tmp)
          })

        })
      }
    },
    searchCountyById() {
      let areaId=this.chinaCountyNow||this.chinaCityNow
      this.axios.get('/tilesapi/tiles/county/price/queryCountyTilesInfoById?areaId=' + areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          let item = res.data.data
          let tmp = {
            area:item.area||'',
            areaId: item.areaId||'',
            parentAreaId:item.parentAreaId||'',
            areaGeo:item.areaGeo||'',
            areaName:item.areaName||'',
            cityName: item.cityName||'',
            provinceName: item.provinceName||'',
            tilesQ1CoverRate: item.tilesQ1CoverRate||'',
            tilesQ1Price: item.tilesQ1Price||'',
            tilesQ2CoverRate: item.tilesQ2CoverRate||'',
            tilesQ2Price: item.tilesQ2Price||'',
            tilesQ3CoverRate: item.tilesQ3CoverRate||'',
            tilesQ3Price: item.tilesQ3Price||'',
            tilesQ4CoverRate: item.tilesQ4CoverRate||'',
            tilesQ4Price: item.tilesQ4Price||'',
          }
          this.searchDetail(tmp)
          this.showDetail()
      })
    }
  },
  watch: {
    curPlaceTab() {
      this.priceResult = []
      this.showCountyNameResult = false
      this.countyName = ''
      this.countyNameResult = ''
      this.countyAreaResult=''
      this.countyQ1CoverRate=''
      this.countyQ2CoverRate=''
      this.countyQ3CoverRate=''
      this.countyQ4CoverRate=''
      this.countyQ1Price=''
      this.countyQ2Price=''
      this.countyQ3Price=''
      this.countyQ4Price=''
      this.areaGeo=''
    },
    countyName(newVal) {
      if (!newVal) {
        this.priceResult=[]
      } else {
        this.searchCountyByName()
      }
    },
    chinaProvinceNow () {
        this.chinaCityNow = ''
        this.chinaCountyNow = ''
        this.chinaCityItems = []
        this.chinaCountyItems = []
        this.$refs.chinaCity?this.$refs.chinaCity.lazySearch = '':'';
        this.$refs.chinaCounty?this.$refs.chinaCounty.lazySearch = '':'';
        if (this.chinaProvinceNow !== ''){
            this.axios.get('/accessapi/searchService/Area/id=' + this.chinaProvinceNow)
                .then((res) => {
                    this.chinaCityItems = res.data.data
                })
            let selected=this.chinaProvinceItems.find((x)=>{return x.areaId === this.chinaProvinceNow});
            this.selectedProvinice=selected.areaName;
            this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
            this.explainPlace=this.selectedProvinice;
        }
    },
    chinaCityNow () {
        this.chinaCountyNow = ''
        this.chinaCountyItems = []
        this.$refs.chinaCounty?this.$refs.chinaCounty.lazySearch = '':'';
        if (this.chinaCityNow !== '')
        {
            this.axios.get('/accessapi/searchService/Area/id=' + this.chinaCityNow)
                .then((res) => {
                    this.chinaCountyItems = res.data.data
                })
            let selected=this.chinaCityItems.find((x)=>{return x.areaId === this.chinaCityNow});
            this.selectedCity=selected.areaName;
            this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
            this.explainPlace=this.selectedProvinice+this.selectedCity;
        }

    },
    chinaCountyNow () {
        if (this.chinaCountyNow !== '') {
            let selected=this.chinaCountyItems.find((x) => {return x.areaId === this.chinaCountyNow});
            this.selectedCounty=selected.areaName;
            this.$store.state.search.selectedRangeStore['china'] = JSON.parse(selected.areaGeojson)
            this.explainPlace=this.selectedProvinice+this.selectedCity+this.selectedCounty;
        }
    },
  }
};
</script>
<style lang="scss" scoped>
//手机端样式
@media screen and (max-width: 800px) and (min-width: 10px){
  *{

    -webkit-touch-callout:none; /*系统默认菜单被禁用*/

    -webkit-user-select:none; /*webkit浏览器*/

    -khtml-user-select:none; /*khtml浏览器*/

    -moz-user-select:none; /*gecko浏览器*/

    -ms-user-select:none; /*ie10+及以下*/

  }

  ::v-deep .vtabs{
    & .theme--light.v-tabs-items{
      background-color: unset;
      height: 100%;
    }
    & .v-window-item .searchField{
      display: flex;
      justify-content: center;
      flex-flow:wrap;
      padding-top: 1.6875rem;
      border-top: 1px solid #afafaf;
    }
    .button_gray{
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 6.25rem;
      height: 1.75rem;
      font-size: 0.75rem;
      min-height:56px;
      text-align: center;
      background: #CCCCCC;
      border-radius: 8px;
      color: white;
      z-index: 1;
    }
    .button_blue{
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 6.25rem;
      height: 1.75rem;
      font-size: 0.75rem;
      min-height:56px;
      text-align: center;
      background: #0066CC;
      border-radius: 8px;
      color: white;
      z-index: 1;
    }
    & .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot {
    min-height: 56px;
  }
  }
  .detail{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 1.87rem 0 0 0.375rem;

    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 1.25rem;
    span{
      color: #3A3A3A;
      margin-left: 0.625rem;
    }

    .left{
      div{
        height: 1.875rem;
        .rmb{
          color: #3A3A3A;
        }
        .price{
          color: #FF4040;
          font-size: 1.25rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          margin-left: unset;
        }
      }
    }
    .right{
      margin-left: 1.875rem;
      div{
        height: 1.875rem;
        .rmb{
          color: #3A3A3A;
        }
        .price{
          color: #FF4040;
          font-size: 1.25rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          margin-left: unset;
        }
      }
    }
  }
  .searchPanel{
    width:21.75rem;
    min-height:21.875rem;
    height:auto;
    background: #F5F5F6;
    border-radius: 2rem 2rem 0rem 0rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.22rem;
  }
  .mapPanel{
    width:21.75rem;
    height:23.5rem;
    border-radius:0rem 0rem 2rem 2rem ;
    margin-left: auto;
    margin-right: auto;
    // border:solid 1px #ff0000;
    margin-bottom: 2rem;
  }
  .topBanner{
    width: 100%;
    height:auto;
    text-align: center;
    border-bottom:solid 1px #cccccc;
    padding: 1.375rem;
  }
  .topTitle {
    width: 100%;
    height: 3.6249999999999996rem;
    line-height: 3.6249999999999996rem;
    font-size: 1.25rem;
    font-weight: 600;
    color: #3A3A3A;
    text-align: center;
    margin-top: 0.5rem;
  }
  .topTip{
    width: 100%;
    height: 0.9375rem;
    line-height: 0.9375rem;
    font-size: 0.625rem;
    color: #4d4d4d;
    text-align: center
  }
  .computerStyle {
    display: none;
  }
  .phoneStyle {
    width: 100vw;
  }
}
@media screen and (min-width: 800px) {
  .computerStyle {
    .topTips{
      position: relative;
      top: 76px;
      width: 100%;
      height: 76px;
      background: #F5F5F6;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      div{
        width: 532px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3A3A;
        line-height: 20px;
        text-align: center;
      }
    }
    .queryDiv{
      position: relative;
      top: 76px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .title{
        // width: 330px;
        height: 42px;
        font-size: 30px !important;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height: 42px;
        margin: 50px 0;
      }
      .mainPanel{
        width: 1280px;
        height: 480px;
        display: flex;

        .mapPanel{
          width: 640px;
          border-radius: 32px 0px 0px 32px;

        }
        .detailPanel{
          width: 640px;
          border-radius: 0px 32px 32px 0px;
          background: #F7F7F7;
          .priceResultList{
            position: absolute;
            width: 565px;
            margin: -60px 0 0 33px;
            background: #F7F7F7;



          }
          .detail{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 30px 0 0 22px;

            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #979797;
            line-height: 20px;
            span{
              color: #3A3A3A;
              margin-left: 10px;
            }

            .left{
              div{
                height: 30px;
                .rmb{
                  color: #3A3A3A;
                }
                .price{
                  color: #FF4040;
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 500;
                  margin-left: unset;
                }
              }
            }
            .right{
              margin-left: 30px;
              div{
                height: 30px;
                .rmb{
                  color: #3A3A3A;
                }
                .price{
                  color: #FF4040;
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 500;
                  margin-left: unset;
                }
              }
            }
          }
        }
      }
    }
    ::v-deep .vtabs{
        // border-radius: 4px;
        // background: #3A3A3A;
        padding: 10px;
        height: 40%;
        & .v-tabs {
          width: unset;
        }
        & .v-tab {
          // width: 100px;
          // height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3A3A3A;
          line-height: 22px;
        }
        // & .v-tabs-bar{
        //     width: 30%;
        // }
        & .v-tabs--grow > .v-tabs-bar .v-tab{
          flex: unset !important;
        }
        & .v-slide-group__content,
        & .v-slide-group__wrapper{
          flex: unset !important;
        }
        & .v-tabs-slider{
            width: 80%;
            margin-left: 10%;
        }
        & .v-text-field > .v-input__control > .v-input__slot:before,
        & .v-text-field > .v-input__control > .v-input__slot:after{
            border-style: unset;
        }
        & textarea{
            // height: 100% !important;
            min-height: 224px;
            max-height: 224px;
            margin: 0 20px;
        }
        & .v-counter{
            margin-right: 20px;
        }
        & label{
            font-size: 14px;
        }
        & .theme--light.v-tabs-items{
          background-color: unset;
          height: 100%;
        }
        & .v-window-item .searchField{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

        }
        & .v-window-item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }
        & .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
          min-height:44px;
        }
        & .v-text-field--outlined .v-label{
          top: 12px;
        }
        & .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
          margin-top: 10px;
        }
    }
    ::v-deep .ant-list-split .ant-list-item{
      border-bottom:unset;
      padding: 6px 0;
    }
    ::v-deep .ant-list-items{
      padding-left:6px !important;
    }
  }
  .phoneStyle{
    display: none;
  }
}

</style>
